<script>
export default {
    beforeRouteEnter(to, from, next) {
        console.log(`to: ${to}`);
        console.log(`from: ${to}`);

        next({ path: '/home' });
    }
};
</script>



// WEBPACK FOOTER //
// src/page/transfer.vue